import TextScramble from '../components/TextScramble';

export default function AboutPage() {
  return (
    <div data-testid="about-page" className="min-h-screen pt-24 sm:pt-28 pb-24 flex items-center justify-center">
      <div className="text-center px-4">
        <TextScramble
          text="&Agrave; propos de nous"
          className="text-5xl sm:text-6xl lg:text-7xl tracking-tighter font-light text-black"
          delay={0.2}
        />
        <p className="mt-6 text-base text-black/30 max-w-md mx-auto">
          Bient&ocirc;t disponible
        </p>
      </div>
    </div>
  );
}
